export default __webpack_public_path__ + "static/media/skill_icon3.5bca11bf.svg";